import { Serializable } from "../utilities/Serializable";

export class CouponType extends Serializable {

    uuid: string;
    code: number;
    description: string;
    price: number;
    daily: boolean;

    constructor() {
        super();
        this.daily = false;
    }
} 


// WEBPACK FOOTER //
// ./src/app/models/CouponType.ts